export default function (value) {
    if (typeof value !== 'number') {
        return value;
    }
    let formatter = new Intl.NumberFormat('nl-NL',{
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    // Return the results of the formatter
    return formatter.format((value / 100));
}